module.exports = __webpack_public_path__ + "static/media/restaurant-14.476c831e.jpg";